var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainedPwd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_875_29708)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#68A395",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7671 11.6461C14.0684 11.6461 14.3244 11.5394 14.5377 11.3274C14.7497 11.1154 14.8564 10.8581 14.8564 10.5568C14.8564 10.2554 14.7497 9.99942 14.5377 9.78608C14.3244 9.57542 14.0684 9.46875 13.7671 9.46875C13.4657 9.46875 13.2097 9.57542 12.9964 9.78742C12.7831 9.99942 12.6777 10.2568 12.6777 10.5581C12.6777 10.8594 12.7844 11.1154 12.9964 11.3288C13.2097 11.5408 13.4657 11.6461 13.7671 11.6461Z",
    fill: "#68A395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5364 21.6278C13.5978 21.6278 12.8018 21.2958 12.1458 20.6318C11.4911 19.9678 11.1644 19.1572 11.1644 18.2012C11.1644 17.1745 11.5631 16.3158 12.3591 15.6252L12.2791 14.5625C11.6778 14.9532 11.1951 15.4705 10.8324 16.1172C10.4698 16.7638 10.2871 17.4585 10.2871 18.2012C10.2871 19.4052 10.7031 20.4278 11.5351 21.2692C12.3671 22.1105 13.3671 22.5305 14.5364 22.5305C15.3684 22.5305 16.1431 22.2692 16.8604 21.7465C17.5778 21.2238 18.1044 20.5732 18.4404 19.7945L17.8031 18.9185C17.6431 19.6972 17.2591 20.3438 16.6484 20.8572C16.0378 21.3705 15.3338 21.6278 14.5364 21.6278Z",
    fill: "#68A395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1761 19.5343H20.6188L18.4414 16.533C18.1401 16.0023 17.7774 15.7356 17.3521 15.7356H14.9081V14.6463H17.0854C17.4748 14.6463 17.6694 14.509 17.6694 14.2343C17.6694 13.9596 17.4748 13.8223 17.0854 13.8223H14.9081V12.7356C14.8721 12.1863 14.5094 11.921 13.8188 11.9383C13.2694 11.9556 12.9961 12.221 12.9961 12.7356V16.533C13.0494 17.0823 13.4121 17.3556 14.0854 17.3556H17.3521L19.2641 19.7996L19.7948 20.6223H21.1761C21.3174 20.6223 21.4414 20.569 21.5481 20.4623C21.6548 20.3556 21.7081 20.2276 21.7081 20.077C21.7081 19.9263 21.6548 19.7983 21.5481 19.6916C21.4414 19.5876 21.3174 19.5343 21.1761 19.5343Z",
    fill: "#68A395"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#E1EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7079 16C19.2133 16 18 17.2133 18 18.7079C18 20.2025 19.2133 21.4158 20.7079 21.4158C22.2025 21.4158 23.4158 20.2025 23.4158 18.7079C23.4158 17.2133 22.2025 16 20.7079 16ZM20.7079 16.8333C21.7425 16.8333 22.5825 17.6733 22.5825 18.7079C22.5825 19.7425 21.7425 20.5825 20.7079 20.5825C19.6733 20.5825 18.8333 19.7425 18.8333 18.7079C18.8333 17.6733 19.6733 16.8333 20.7079 16.8333Z",
    fill: "#68A395"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.535 18.7402L21.4512 17.7981C21.6117 17.6331 21.8758 17.6294 22.0404 17.7898C22.2054 17.9502 22.2092 18.2139 22.0487 18.3789L20.8337 19.6281C20.7554 19.7089 20.6475 19.7544 20.535 19.7544C20.4225 19.7544 20.315 19.7089 20.2362 19.6281L19.3679 18.7352C19.2075 18.5702 19.2112 18.3064 19.3762 18.146C19.5412 17.9856 19.805 17.9894 19.9654 18.1544L20.535 18.7402Z",
    fill: "#68A395"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_875_29708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainedPwd);
export default __webpack_public_path__ + "static/media/trained_PWD.0b748d41761fdd45aaa557c2d8056cc3.svg";
export { ForwardRef as ReactComponent };